<script setup lang="ts">
import { computed } from "vue";

const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
  <footer class="bg-white border-t border-gray-200 py-6 px-6">
    <div
      class="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-600"
    >
      <!-- Copyright -->
      <div>
        <p>&copy; {{ currentYear }} A4U Prices. All rights reserved.</p>
      </div>

      <!-- Links -->
      <div class="flex items-center gap-6">
        <a href="#" class="hover:text-primary transition-colors"
          >Documentation</a
        >
        <a href="#" class="hover:text-primary transition-colors">Support</a>
        <a href="#" class="hover:text-primary transition-colors">Privacy</a>
      </div>
    </div>
  </footer>
</template>
